// extracted by mini-css-extract-plugin
module.exports = {"landingContainer":"Stats_landingContainer__Pa9Ma","darkWrapper":"Stats_darkWrapper__d6ywt","darkWrapper__twin":"Stats_darkWrapper__twin__RK37S","stats":"Stats_stats__1Yg75"};